import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function CpfValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let value = control.value;

    if (!value) {
      return null;
    }

    value = value.replace(/\D+/g, '');

    const lengthValidation = value.length !== 11;

    const invalidCpf =
      value == '00000000000' ||
      value == '11111111111' ||
      value == '22222222222' ||
      value == '33333333333' ||
      value == '44444444444' ||
      value == '55555555555' ||
      value == '66666666666' ||
      value == '77777777777' ||
      value == '88888888888' ||
      value == '99999999999';

    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(value.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    const firstDv = rev != parseInt(value.charAt(9));

    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(value.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    const secondDv = rev != parseInt(value.charAt(10));

    const cpf = !(lengthValidation || invalidCpf || firstDv || secondDv);

    return !cpf
      ? {
          cpf: {
            valid: false,
          },
        }
      : null;
  };
}
